import React from 'react';
import { shouldDisableGoogleAuth } from '../utils/browserDetection';
import { useI18n } from '../i18n';
import './LoginModal.css';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoogleLogin: () => void;
  message?: string;
  actionName?: string;
}

const LoginModal: React.FC<LoginModalProps> = ({ 
  isOpen, 
  onClose, 
  onGoogleLogin,
  message,
  actionName = "此功能"
}) => {
  const { t } = useI18n();

  if (!isOpen) return null;

  const resolvedActionName = actionName === "此功能" ? t('login.defaultAction') : actionName;
  const defaultMessage = t('login.defaultMessage', { actionName: resolvedActionName });
  const disableGoogle = shouldDisableGoogleAuth();

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="login-modal-header">
          <h3>{t('login.requiredTitle')}</h3>
          <button className="login-modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="login-modal-body">
          <div className="login-modal-icon">
            <i className="fas fa-cloud-upload-alt"></i>
          </div>
          <p className="login-modal-message">
            {message || defaultMessage}
          </p>
          <p className="login-modal-sub-message">
            {t('login.afterLogin')}
          </p>
          <ul className="login-modal-benefits">
            <li>
              <i className="fas fa-heart"></i>
              {t('login.benefitFavorites')}
            </li>
            <li>
              <i className="fas fa-tags"></i>
              {t('login.benefitTags')}
            </li>
            <li>
              <i className="fas fa-share-alt"></i>
              {t('login.benefitShareHistory')}
            </li>
            <li>
              <i className="fas fa-sync-alt"></i>
              {t('login.benefitSync')}
            </li>
          </ul>
        </div>
        
        <div className="login-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            {t('login.skip')}
          </button>
          
          <div className="login-buttons-container">
            {!disableGoogle && (
              <button className="btn btn-google login-modal-login-btn" onClick={onGoogleLogin}>
                <i className="fab fa-google"></i>
                {t('login.google')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal; 
